{
  "actionButtons": {
    "deselectAll": "Deselect all",
    "export": "Export",
    "exportAsCsv": "as a CSV",
    "exportAsPdf": "as a PDF",
    "selectAll": "Select all"
  },
  "areYouSureModal": {
    "cancelText": "Cancel",
    "confirmText": "Confirm",
    "title": "Confirm Action"
  },
  "columnManager": {
    "columns": "Columns",
    "hiddenColumns": "Hidden columns",
    "noColumnsMatch": "No columns found",
    "pinnedColumns": "Pinned columns",
    "searchPlaceholder": "Search columns...",
    "visibleColumns": "Visible columns"
  },
  "coordinates": {
    "latitude": "Latitude",
    "latitudePlaceholder": "e.g., -48.8566",
    "latitudeTooltip": "Geographic coordinate specifying the north-south position of the business partner's address. Use decimal degree format (DD): values range from -90° (South Pole) to +90° (North Pole)",
    "longitude": "Longitude",
    "longitudePlaceholder": "e.g., 2.3522",
    "longitudeTooltip": "Geographic coordinate specifying the east-west position of the business partner's address. Use decimal degree format (DD): values range from -180° (westward) to +180° (eastward)."
  },
  "copy": "{{text}} copied to clipboard",
  "countries": {
    "AC": "Ascension Island",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua & Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "Åland Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia & Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "St. Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BQ": "Caribbean Netherlands",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Congo - Kinshasa",
    "CF": "Central African Republic",
    "CG": "Congo - Brazzaville",
    "CH": "Switzerland",
    "CI": "Côte d’Ivoire",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CP": "Clipperton Island",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Curaçao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czechia",
    "DE": "Germany",
    "DG": "Diego Garcia",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EA": "Ceuta & Melilla",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "EU": "European Union",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GS": "South Georgia & South Sandwich Islands",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong SAR China",
    "HM": "Heard & McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "IC": "Canary Islands",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "St. Kitts & Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "St. Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "St. Martin",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar (Burma)",
    "MN": "Mongolia",
    "MO": "Macao SAR China",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "St. Pierre & Miquelon",
    "PN": "Pitcairn Islands",
    "PR": "Puerto Rico",
    "PS": "Palestinian Territories",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "St. Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard & Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "São Tomé & Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Eswatini",
    "TA": "Tristan da Cunha",
    "TC": "Turks & Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern Territories",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad & Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "U.S. Outlying Islands",
    "UN": "Unknown",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Vatican City",
    "VC": "St. Vincent & Grenadines",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "VI": "U.S. Virgin Islands",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis & Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  },
  "countriesEcobalyse": {
    "BD": "Bangladesh",
    "CN": "China",
    "FR": "France",
    "IN": "India",
    "KH": "Cambodia",
    "MA": "Morocco",
    "MM": "Myanmar",
    "PK": "Pakistan",
    "RAF": "Africa Region",
    "RAS": "Asia Region",
    "REE": "Eastern European Region",
    "REO": "Western European Region",
    "RLA": "Latin America Region",
    "RME": "Middle East Region",
    "RNA": "North America Region",
    "ROC": "Oceania Region",
    "TN": "Tunisia",
    "TR": "Turkey",
    "VN": "Vietnam"
  },
  "dataLoad": {
    "error": {
      "message": "Something happened while loading the list. Please try again later.",
      "title": "Something went wrong"
    },
    "noResults": {
      "message": "We couldn't find any record for your organization. Please try again.",
      "title": "No results"
    }
  },
  "documentUpload": {
    "helptext": "Maximum size: {{ maxSize }} MB",
    "missingDocument": "Unable to find document",
    "title": "Drag and drop your files here or click to select files",
    "uploadSuppliers": "Pre-check file"
  },
  "error": {
    "default": "An error occurred",
    "message": "message",
    "title": "title"
  },
  "fabricProcess": {
    "knitting-circular": "Circular knitting",
    "knitting-fully-fashioned": "Fully-fashioned knitting",
    "knitting-integral": "Integral knitting",
    "knitting-mix": "Knitting mix",
    "knitting-straight": "Straight knitting",
    "weaving": "Weaving"
  },
  "filter": "Filter",
  "filter_false": "No",
  "filter_true": "Yes",
  "form": {
    "reset": "Reset",
    "save": "Save"
  },
  "languages": {
    "arabic": "Arabic",
    "belarusian": "Belarusian",
    "chinese": "Chinese",
    "dutch": "Dutch",
    "english": "English",
    "french": "French",
    "german": "German",
    "italian": "Italian",
    "japanese": "Japanese",
    "korean": "Korean",
    "lithuanian": "Lithuanian",
    "portuguese": "Portuguese",
    "romanian": "Romanian",
    "spanish": "Spanish",
    "turkish": "Turkish"
  },
  "lists": {
    "noData": {
      "title": "No Data"
    }
  },
  "menus": {
    "admin": "Back Office",
    "businessPartners": "Business Partners",
    "certificates": "Documents",
    "communicationStudio": "Studio: your central hub to shape and control how product information is displayed to your end-consumers. It allows you to manage content, configure translations, define layout structures, and set up dynamic rules to preserve brand integrity and ensure consistent storytelling across your tools (websites, stores, etc.).",
    "dashboard": "Dashboard",
    "dataTransfer": "Data Hub",
    "faq": "FAQ",
    "invoices": "My Invoices",
    "logout": "Logout",
    "products": "Catalog",
    "profile": "My Profile",
    "regulations": "Regulations"
  },
  "showOnlyMainFabric": "Main component",
  "simulation": {
    "notSubscribed": {
      "message": "message",
      "title": "title"
    }
  },
  "sort": {
    "ascending": "Ascending",
    "descending": "Descending",
    "search": {
      "placeholder": "Search"
    },
    "title": "Sort"
  },
  "success": {
    "message": "Successfully completed action",
    "title": "Success"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "Privacy Policy"
    },
    "menu": {
      "contacts": "Business Partners",
      "documentation": "Documentation",
      "loggedAs": "You are logged as",
      "productionSites": "Production Sites",
      "requests": "Requests",
      "supplierRequests": "Suppliers"
    }
  },
  "table": {
    "filter": {
      "date": {
        "preset": {
          "custom": "Custom date",
          "oneMonthAgo": "One month ago",
          "oneMonthFromNow": "One month from now",
          "oneWeekAgo": "One week ago",
          "oneWeekFromNow": "One week from now",
          "oneYearAgo": "One year ago",
          "oneYearFromNow": "One year from now",
          "today": "Today",
          "tomorrow": "Tomorrow",
          "yesterday": "Yesterday"
        }
      },
      "operator": {
        "after": "Is after",
        "afterOrEquals": "Is on or after",
        "before": "Is before",
        "beforeOrEquals": "Is on or before",
        "between": "Is between",
        "empty": "Is empty",
        "equals": "Is",
        "isEmpty": "isEmpty",
        "isNotEmpty": "isNotEmpty",
        "notBetween": "Is not between",
        "notEmpty": "Is not empty",
        "notEquals": "Is not"
      }
    },
    "hideColumn": "Hide",
    "manageColumns": "Manage columns",
    "noDataMessage": "No data to display",
    "noDataTitle": "No results found",
    "pinColumn": "Pin",
    "rowsPerPage": "Rows per page",
    "showColumn": "Show",
    "total": "Total: ",
    "unpinColumn": "Unpin",
    "views": {
      "add": {
        "error": {
          "message": "Failed to create view",
          "title": "Failed to create view"
        },
        "success": {
          "message": "View created successfully",
          "title": "View created"
        }
      },
      "delete": {
        "error": {
          "message": "Failed to delete view",
          "title": "Failed to delete view"
        },
        "modal": {
          "cancel": "Cancel",
          "delete": "Delete",
          "description": "Are you sure you want to delete the view {{viewName}} ? This action is irreversible.",
          "title": "Confirmation"
        },
        "success": {
          "message": "View deleted successfully",
          "title": "View deleted"
        }
      },
      "modal": {
        "description": "Save the active view of the data table to access it later. Sorting, filtering, and column configuration will be saved.",
        "pinnedToDashboard": {
          "label": "Pin on dashboard",
          "tooltip": "A shortcut added to the Spotlights section of the dashboard will provide one-click access to this view."
        },
        "reset": "Reset",
        "save": "Save (beta)",
        "title": "Active view (beta)",
        "update": "Update"
      },
      "update": {
        "error": {
          "message": "Failed to update view",
          "title": "Failed to update view"
        },
        "success": {
          "message": "View updated successfully",
          "title": "View updated"
        }
      },
      "viewName": "Name",
      "viewNamePlaceholder": "Enter view name"
    }
  },
  "zodErrors": {
    "errorDefault": "Invalid value",
    "invalidEmail": "Invalid email address",
    "latitudeOutOfRange": "Latitude must be between -90 and +90",
    "longitudeOutOfRange": "Longitude must be between -180 and +180",
    "mustContainBothLatitudeAndLongitude": "Both latitude and longitude must be provided",
    "noSpecialCharacters": "The value must contain more than 2 characters and must not contain special characters",
    "ValueTooLong": "Value too long",
    "ValueTooShort": "Value too short"
  }
}
